import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ApiService } from '@edgvr-front/api/data-access';
import {
  DataModuleEntityRaw,
  DataPageLimit,
  DataPersonEntityRaw,
  DataWorkshopEntityRaw,
} from '@edgvr-front/data/domain';
import { Observable } from 'rxjs';
import {
  DataModuleGetRequestDTO,
  DataModuleGetResponseDTO,
  DataModulesListRequestDTO,
  DataModulesListResponseDTO,
  DataPersonGetRequestDTO,
  DataPersonGetResponseDTO,
  DataPersonsListRequestDTO,
  DataPersonsListResponseDTO,
  DataWorkshopGetRequestDTO,
  DataWorkshopGetResponseDTO,
  DataWorkshopsListRequestDTO,
  DataWorkshopsListResponseDTO,
} from '../dto';

@Injectable()
export class DataService {
  constructor(private readonly apiService: ApiService) {}

  dataModuleGet(
    dataModuleGetRequestDTO: DataModuleGetRequestDTO
  ): Observable<DataModuleGetResponseDTO> {
    const { id } = dataModuleGetRequestDTO.data;

    return this.apiService.get<DataModuleEntityRaw>(`data/modules/${id}`).pipe(
      map(
        (_) =>
          new DataModuleGetResponseDTO({
            dataModule: _,
          })
      )
    );
  }

  dataModulesList(
    dataModulesListRequestDTO: DataModulesListRequestDTO
  ): Observable<DataModulesListResponseDTO> {
    const { page, moduleName, from, to } = dataModulesListRequestDTO.data;

    const params = new URLSearchParams();
    params.append('limit', DataPageLimit + '');
    params.append('offset', (page - 1) * DataPageLimit + '');

    if (moduleName) {
      params.append('moduleName', moduleName);
    }

    if (from) {
      params.append('from', from + '');
    }

    if (to) {
      params.append('to', to + '');
    }

    return this.apiService
      .get<{ dataModules: DataModuleEntityRaw[]; count: number }>(
        `data/modules?${params}`
      )
      .pipe(
        map(
          (_) =>
            new DataModulesListResponseDTO({
              dataModules: _.dataModules,
              count: _.count,
            })
        )
      );
  }

  dataPersonGet(
    dataModuleGetRequestDTO: DataPersonGetRequestDTO
  ): Observable<DataPersonGetResponseDTO> {
    const { id } = dataModuleGetRequestDTO.data;

    return this.apiService.get<DataPersonEntityRaw>(`data/persons/${id}`).pipe(
      map(
        (_) =>
          new DataPersonGetResponseDTO({
            dataPerson: _,
          })
      )
    );
  }

  dataPersonsList(
    dataPersonsListRequestDTO: DataPersonsListRequestDTO
  ): Observable<DataPersonsListResponseDTO> {
    const { page, personName, from, to } = dataPersonsListRequestDTO.data;

    const params = new URLSearchParams();
    params.append('limit', DataPageLimit + '');
    params.append('offset', (page - 1) * DataPageLimit + '');

    if (personName) {
      params.append('personName', personName);
    }

    if (from) {
      params.append('from', from + '');
    }

    if (to) {
      params.append('to', to + '');
    }

    return this.apiService
      .get<{ dataPersons: DataPersonEntityRaw[]; count: number }>(
        `data/persons?${params}`
      )
      .pipe(
        map(
          (_) =>
            new DataPersonsListResponseDTO({
              dataPersons: _.dataPersons,
              count: _.count,
            })
        )
      );
  }

  dataWorkshopGet(
    dataWorkshopGetRequestDTO: DataWorkshopGetRequestDTO
  ): Observable<DataWorkshopGetResponseDTO> {
    const { id } = dataWorkshopGetRequestDTO.data;

    return this.apiService
      .get<DataWorkshopEntityRaw>(`data/workshops/${id}`)
      .pipe(
        map(
          (_) =>
            new DataWorkshopGetResponseDTO({
              dataWorkshop: _,
            })
        )
      );
  }

  dataWorkshopsList(
    dataWorkshopsListRequestDTO: DataWorkshopsListRequestDTO
  ): Observable<DataWorkshopsListResponseDTO> {
    const { page, workshopName, from, to } = dataWorkshopsListRequestDTO.data;

    const params = new URLSearchParams();
    params.append('limit', DataPageLimit + '');
    params.append('offset', (page - 1) * DataPageLimit + '');

    if (workshopName) {
      params.append('workshopName', workshopName);
    }

    if (from) {
      params.append('from', from + '');
    }

    if (to) {
      params.append('to', to + '');
    }

    return this.apiService
      .get<{ dataWorkshops: DataWorkshopEntityRaw[]; count: number }>(
        `data/workshops?${params}`
      )
      .pipe(
        map(
          (_) =>
            new DataWorkshopsListResponseDTO({
              dataWorkshops: _.dataWorkshops,
              count: _.count,
            })
        )
      );
  }
}
